import React from 'react';
import '../styles/Footer.css';

export default function Footer() {
    return (
        <div className='main-footer'>
            <div className='container'>
                <div className="grid" style={{justifyContent: "center"}}>
                    {/* Column2*/}
                    <div className='col-30 col-50s' style={{ textAlign: "center", width: "100%"}}>
                            <h6><text className="contatti" onClick={()=> window.open("mailto:filosofinerba@gmail.com")}>filosofinerba@gmail.com</text></h6>
                            <h6><text className="contatti" onClick={()=> window.open("https://www.instagram.com/filosofi_in_erba/", "_blank")}>@filosofi_in_erba</text></h6>
                            <h6><text className="contatti" onClick={()=> window.open("https://www.instagram.com/filosofi.in.erba.cbd/", "_blank")}>@filosofi.in.erba.cbd</text></h6>
                            <h6><text className="contatti" onClick={()=> window.open("https://t.me/GrowersinErba", "_blank")}>Growers in Erba</text></h6>
                            <h6><text className="contatti" onClick={()=> window.open("https://www.youtube.com/c/filosofi_in_erba", "_blank")}>Filosofi in Erba</text></h6>
                            <br/>
                            <h6  style={{justifyContent: "center", marginBottom: "5%", textShadow: "2px 2px 8px black"}}>
                        &copy;2019-{new Date().getFullYear()} Filosofi In Erba |&nbsp;
                        <text  className="contatti" onClick={()=> window.open("https://www.iubenda.com/privacy-policy/24709192/cookie-policy", "_blank")}>Cookies</text> |&nbsp;
                        <text  className="contatti" onClick={()=> window.open("https://www.iubenda.com/termini-e-condizioni/24709192", "_blank")}>Termini e Condizioni</text> |&nbsp;
                        <text  className="contatti" onClick={()=> window.open("https://www.iubenda.com/privacy-policy/24709192", "_blank")}>Privacy</text>
                    </h6>
                    </div>
                </div>
            </div>
        </div>
    );
}